

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const OVERVIEW_API_URL = '/analysis/overview/';
const COVERAGE_RECOVERY_AND_PENDING_API_URL = 'analysis/coverage-s1/';
const COVERAGE_ACTION_CODE_COVERAGE_API_URL = 'analysis/coverage-s2/';
const COVERAGE_HML_API_URL = 'analysis/hml-categorization/'

export const fetchAnalysis = createAsyncThunk(
    'analysis/fetchAnalysis',
    async (params, thunkAPI) => {
        try {
            const state = thunkAPI.getState();
            const token = state.auth.token;
            const trusts = state.trust.selected_trusts;
            const query = state.filters.query;

            if (!token) {
                return;
            }

            const queryParams = {  };

            // Add selected trust IDs
            if (Array.isArray(query?.trust_id) && query?.trust_id.length !== 0) {
                queryParams.portfolio_id = query?.trust_id?.join(',');
            }
            if (Array.isArray(query?.state) && query.state.length !== 0) {
                queryParams.state = query.state.join(',');
            }
            if (Array.isArray(query?.region) && query.region.length !== 0) {
                queryParams.region = query.region.join(',');
            }
            if (Array.isArray(query?.status) && query.status.length !== 0) {
                queryParams.status = query.status.join(',');
            }
            if (Array.isArray(query?.date_to) && query.date_to.length !== 0) {
                queryParams.date_to = query.date_to.join(',');
            }
            if (Array.isArray(query?.date_from) && query.date_from.length !== 0) {
                queryParams.date_from = query.date_from.join(',');
            }
            if (Array.isArray(query?.agency) && query.agency.length !== 0) {
                queryParams.agency = query.agency.join(',');
            }
            if (Array.isArray(query?.loan_type
            ) && query.loan_type
                .length !== 0) {
                queryParams.loan_type
                    = query.loan_type
                        .join(',');
            }

            if (Array.isArray(query?.team_member) && query.team_member.length !== 0) {
                queryParams.team_member = query.team_member.join(',');
            }
            if (Array.isArray(query?.team_leader) && query.team_leader.length !== 0) {
                queryParams.team_leader = query.team_leader.join(',');
            }



            const response = await axios.get(OVERVIEW_API_URL, {
                params: queryParams,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            return response.data?.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message || 'Failed to fetch analysis'
            );
        }
    }
);


// ------- Analysis coverage Recovery vs Pending

export const fetchAnalysisCoverage = createAsyncThunk(
    'analysis/fetchAnalysisCoverage',
    async (params, thunkAPI) => {
        try {
            const state = thunkAPI.getState();
            const token = state.auth.token;
            const trusts = state.trust.selected_trusts;


            if (!token) {
                return;
            }


            const query = state.filters?.query || {};
            const queryParams = {};
            if (Array.isArray(query?.trust_id) && query?.trust_id.length !== 0) {
                queryParams.portfolio_id = query?.trust_id?.join(',');
            }
            if (Array.isArray(query?.date_to) && query.date_to.length !== 0) {
                queryParams.date_to = query.date_to.join(',');
            }
            if (Array.isArray(query?.date_from) && query.date_from.length !== 0) {
                queryParams.date_from = query.date_from.join(',');
            }
            if (Array.isArray(query?.team_member) && query.team_member.length !== 0) {
                queryParams.team_member = query.team_member.join(',');
            }
            if (Array.isArray(query?.team_leader) && query.team_leader.length !== 0) {
                queryParams.team_leader = query.team_leader.join(',');
            }
            if (Array.isArray(query?.state) && query.state.length !== 0) {
                queryParams.state = query.state.join(',');
            }
            if (Array.isArray(query?.region) && query.region.length !== 0) {
                queryParams.region = query.region.join(',');
            }
            if (Array.isArray(query?.status) && query.status.length !== 0) {
                queryParams.status = query.status.join(',');
            }

            if (Array.isArray(query?.agency) && query.agency.length !== 0) {
                queryParams.agency = query.agency.join(',');
            }
            if (Array.isArray(query?.loan_type
            ) && query.loan_type
                .length !== 0) {
                queryParams.loan_type
                    = query.loan_type
                        .join(',');
            }
            // ----------------------------------------------------------------------
            const response = await axios.get(COVERAGE_RECOVERY_AND_PENDING_API_URL, {
                params: queryParams,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            return response.data?.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message || 'Failed to fetch analysis'
            );
        }
    }
);

// analysis coverage Action Code Coverage

export const fetchAnalysisCoverageCode = createAsyncThunk(
    'analysis/fetchAnalysisCoverageCode',
    async (params, thunkAPI) => {
        try {
            const state = thunkAPI.getState();
            const token = state.auth.token;
            const trusts = state.trust.selected_trusts;


            if (!token) {
                return;
            }


            const query = state.filters?.query || {};
            const queryParams = { };
            if (Array.isArray(query?.trust_id) && query?.trust_id.length !== 0) {
                queryParams.portfolio_id = query?.trust_id?.join(',');
            }
            if (Array.isArray(query?.date_to) && query.date_to.length !== 0) {
                queryParams.date_to = query.date_to.join(',');
            }
            if (Array.isArray(query?.date_from) && query.date_from.length !== 0) {
                queryParams.date_from = query.date_from.join(',');
            }
            if (Array.isArray(query?.team_member) && query.team_member.length !== 0) {
                queryParams.team_member = query.team_member.join(',');
            }
            if (Array.isArray(query?.team_leader) && query.team_leader.length !== 0) {
                queryParams.team_leader = query.team_leader.join(',');
            }
            if (Array.isArray(query?.state) && query.state.length !== 0) {
                queryParams.state = query.state.join(',');
            }
            if (Array.isArray(query?.region) && query.region.length !== 0) {
                queryParams.region = query.region.join(',');
            }
            if (Array.isArray(query?.status) && query.status.length !== 0) {
                queryParams.status = query.status.join(',');
            }

            // ----------------------------------------------------------------------
            const response = await axios.get(COVERAGE_ACTION_CODE_COVERAGE_API_URL, {
                params: queryParams,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            return response.data?.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message || 'Failed to fetch analysis'
            );
        }
    }
);


// HML Categorization

export const fetchHMLCategorization = createAsyncThunk(
    'analysis/fetchAnalysishml',
    async (params, thunkAPI) => {
        try {
            const state = thunkAPI.getState();
            const token = state.auth.token;
            const trusts = state.trust.selected_trusts;
            const { team_member, team_leader } = params;

            if (!token) {
                return;
            }


            const query = state.filters?.query || {};
            const queryParams = {};
            if (Array.isArray(query?.trust_id) && query?.trust_id.length !== 0) {
                queryParams.portfolio_id = query?.trust_id?.join(',');
            }
            if (Array.isArray(query?.date_to) && query.date_to.length !== 0) {
                queryParams.date_to = query.date_to.join(',');
            }
            if (Array.isArray(query?.date_from) && query.date_from.length !== 0) {
                queryParams.date_from = query.date_from.join(',');
            }
            if (Array.isArray(query?.team_member) && query.team_member.length !== 0) {
                queryParams.team_member = query.team_member.join(',');
            }
            if (Array.isArray(query?.team_leader) && query.team_leader.length !== 0) {
                queryParams.team_leader = query.team_leader.join(',');
            }
            if (Array.isArray(query?.state) && query.state.length !== 0) {
                queryParams.state = query.state.join(',');
            }
            if (Array.isArray(query?.region) && query.region.length !== 0) {
                queryParams.region = query.region.join(',');
            }
            if (Array.isArray(query?.status) && query.status.length !== 0) {
                queryParams.status = query.status.join(',');
            }

            if (Array.isArray(query?.agency) && query.agency.length !== 0) {
                queryParams.agency = query.agency.join(',');
            }

            if (Array.isArray(team_member) && team_member.length !== 0) {
                queryParams.team_member = team_member.join(',');
            }
            if (Array.isArray(team_leader) && team_leader.length !== 0) {
                queryParams.team_leader = team_leader.join(',');
            }

            if (Array.isArray(query?.loan_type
            ) && query.loan_type
                .length !== 0) {
                queryParams.loan_type
                    = query.loan_type
                        .join(',');
            }
            // ----------------------------------------------------------------------
            const response = await axios.get(COVERAGE_HML_API_URL, {
                params: queryParams,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });
         
            return response?.data?.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message || 'Failed to fetch analysis'
            );
        }
    }
);

// --------------------------- end thunk ---------------
const initialState = {
    analysis_overview: [],
    overview_loading: false,
    error: null,

    analysis_coverage: {
        recovery_and_pending: [],
        action_code_coverage: [],
        hml_categorization: [],
        error: null,
        loading: false,
    },
};

const analysisSlice = createSlice({
    name: 'analysis',
    initialState,
    reducers: {
        clearAnalysis: (state) => {
            state.analysis_overview = {};
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAnalysis.pending, (state) => {
                state.overview_loading = true;
                state.error = null;
            })
            .addCase(fetchAnalysis.fulfilled, (state, action) => {
                state.overview_loading = false;
                state.analysis_overview = action.payload;
            })

            .addCase(fetchAnalysis.rejected, (state, action) => {
                state.overview_loading = false;
                state.error = action.payload || 'Something went wrong';
                state.analysis_overview = []
                state.error = null
            })

            // ------- Analysis coverage
            .addCase(fetchAnalysisCoverage.pending, (state) => {

                state.analysis_coverage = {
                    ...state.analysis_coverage,
                    loading: true,
                    error: null,

                }
            })
            .addCase(fetchAnalysisCoverage.fulfilled, (state, action) => {

                state.analysis_coverage = {
                    ...state.analysis_coverage,
                    recovery_and_pending: action.payload,
                    loading: false,
                    error: null,

                }

            })
            .addCase(fetchAnalysisCoverage.rejected, (state, action) => {
                state.analysis_coverage = {
                    ...state.analysis_coverage,
                    recovery_and_pending: [],
                    loading: false,
                    error: action.payload || 'Something went wrong',

                }

            })


            // coverage action code 
            .addCase(fetchAnalysisCoverageCode.pending, (state) => {

                state.analysis_coverage = {
                    ...state.analysis_coverage,
                    loading: true,
                    error: null,

                }
            })
            .addCase(fetchAnalysisCoverageCode.fulfilled, (state, action) => {

                state.analysis_coverage = {
                    ...state.analysis_coverage,
                    action_code_coverage: action.payload,
                    loading: false,
                    error: null,

                }

            })
            .addCase(fetchAnalysisCoverageCode.rejected, (state, action) => {
                state.analysis_coverage = {
                    ...state.analysis_coverage,
                    action_code_coverage: [],
                    loading: false,
                    error: action.payload || 'Something went wrong',

                }

            })

            // ----------- HML Categorization -----------
            .addCase(fetchHMLCategorization.pending, (state) => {

                state.analysis_coverage = {
                    ...state.analysis_coverage,
                    loading: true,
                    error: null,

                }
            })
            .addCase(fetchHMLCategorization.fulfilled, (state, action) => {

                state.analysis_coverage = {
                    ...state.analysis_coverage,
                    hml_categorization: action.payload,
                    loading: false,
                    error: null,

                }

            })
            .addCase(fetchHMLCategorization.rejected, (state, action) => {
                state.analysis_coverage = {
                    ...state.analysis_coverage,
                    hml_categorization: [],
                    loading: false,
                    error: action.payload || 'Something went wrong',

                }

            });


    },
});

export const { clearAnalysis } = analysisSlice.actions;
export default analysisSlice.reducer;
